module.exports = __webpack_public_path__ + "img/2.ff746761.jpg";